"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthProcess = void 0;
/*import {getInitialAuthTokens} from "../../../../apis/AuthApis";
import {getAuthInfo} from "../../../../apis";
import {mapApiToLau, mapApiToUserInfo} from "../../../../apis/maps/PasportMaps";
*/
const useAuthTokens_1 = require("./useAuthTokens");
const Storage_1 = require("../../Storage");
const AuthProvider_1 = require("../providers/AuthProvider");
const auth_api_1 = require("../apis/auth.api");
const pasport_api_1 = require("../apis/pasport.api");
const pasport_maps_1 = require("../apis/pasport.maps");
const useAuthProcess = () => {
    const { authTokens, saveAuthTokens } = (0, useAuthTokens_1.useAuthTokens)();
    const [getCodeVerifier, setCodeVerifier] = (0, Storage_1.useStorage)("codeVerifier");
    const authProcessState = 'refreshingToken';
    const dispatch = (0, AuthProvider_1.useAuthDispatch)();
    //authCode is code given to fe after login with credentials
    const loginByAuthCode = async (authCode) => {
        const codeVerifier = getCodeVerifier() || '';
        return (0, auth_api_1.getInitialAuthTokens)({
            authCode, codeVerifier
        }).then(response => {
            const accessToken = response?.access_token;
            const refreshToken = response?.refreshToken || '';
            saveAuthTokens({
                accessToken, refreshToken
            });
        });
    };
    const loadAuthInfo = () => {
        const accessToken = authTokens?.accessToken;
        if (accessToken) {
            (0, pasport_api_1.getAuthInfo)({
                jwtToken: accessToken
            }).then(response => {
                dispatch(AuthProvider_1.AuthAction.setAuthInfo({
                    userInfo: (0, pasport_maps_1.mapApiToUserInfo)(response.userInfo),
                    lauList: response.lauList.map(item => (0, pasport_maps_1.mapApiToLau)(item)),
                }));
            });
        }
    };
    return {
        authProcessState,
        loginByAuthCode,
        saveAuthTokens,
        loadAuthInfo, //TODO
        authTokens,
        setCodeVerifier,
        getCodeVerifier
    };
};
exports.useAuthProcess = useAuthProcess;
